import React, { memo } from 'react';
import styled from 'styled-components';
import BlockWithVisible from './BlockWithVisible';
import WorkInfoRowBase, { PrimaryBlock, PrimaryText, WorkInfoRowProps } from './WorkInfoRowBase';

const AttributedWorkInfo: React.FC<WorkInfoRowProps> = (props) => (
  <WorkInfoRowBase {...props}>
    {({ title, artistName, isHover, isActive }) => (
      <>
        <ArtistNameBlock $isHover={isHover} $isActive={isActive}>
          <PrimaryText>
            {artistName || '-'}
          </PrimaryText>
        </ArtistNameBlock>
        <BlockWithVisible
          width="2.5"
          value={title || '-'}
          isHover={isHover}
          isActive={isActive}
        />
      </>
    )}
  </WorkInfoRowBase>
);

export default memo(AttributedWorkInfo);

const ArtistNameBlock = styled(PrimaryBlock)`
  flex: 1.2;
`;
